import { SnackbarGateway } from '@/domain/snackbar/gateways/snackbar.gateway';
import { createAppAsyncThunk } from '@/domain/store.thunk';
import { translate } from '@/ui/i18n';

import { dispatchTwiceGetImpactCalculateTour } from './utils/dispatch-twice-get-impact-calculate-tour';

type Params = {
  projectId: number;
};

type Result = void;

export const runImpactCalculateTourEnvForProject = createAppAsyncThunk(
  'impactCalculateTour/runImpactCalculateTourEnvForProject',
  async (
    params: Params,
    { extra: { impactCalculateTourGateway, snackbarGateway }, dispatch },
  ): Promise<Result> => {
    try {
      await impactCalculateTourGateway.runImpactCalculateTourEnvForProject(
        params.projectId,
      );
      dispatchTwiceGetImpactCalculateTour(dispatch, params.projectId);
    } catch (error) {
      showSnackbarError(snackbarGateway);
      throw error;
    }
  },
);

function showSnackbarError(snackbarGateway: SnackbarGateway) {
  snackbarGateway.error(translate('GetImpactCalculate.Message.error'));
}
